import React from "react";

export function Card({tone="default",interactive=false,pad="md",children,style,...rest}){
  const [hover,setHover]=React.useState(false);
  const TONES={
    default:{background:"var(--surface-card)",border:"var(--border-default)",color:"var(--fg-1)"},
    sunken:{background:"var(--surface-sunken)",border:"var(--border-hairline)",color:"var(--fg-1)"},
    brand:{background:"var(--surface-brand)",border:"1px solid var(--surface-brand)",color:"var(--fg-invert)"},
    accent:{background:"var(--surface-accent-soft)",border:"1px solid var(--cyan-200)",color:"var(--teal-900)"},
    outline:{background:"transparent",border:"var(--border-ink)",color:"var(--fg-1)"}
  };
  const PAD={none:0,sm:"16px",md:"var(--card-pad)",lg:"var(--card-pad-lg)"};
  return (
    <div
      onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
      style={{borderRadius:"var(--radius-card)",padding:PAD[pad],transition:"var(--transition-surface),var(--transition-control)",
        cursor:interactive?"pointer":"default",
        ...TONES[tone],
        ...(interactive&&hover?{boxShadow:"var(--shadow-pop)",transform:"translateY(-2px)",borderColor:"var(--line-accent)"}:null),
        ...style}}
      {...rest}>
      {children}
    </div>
  );
}
